module.exports = __webpack_public_path__ + "img/h2p-deck.20b2557c.png";